let debugMode = 1;
  
let isFansPage = location.pathname.includes("cooling-range"),
    isSparePage = location.pathname.includes("spares"),
    isAirconPage = location.pathname.includes("collections/air-conditioners"),
    isCommDehumidifiersPage = location.pathname.includes("commercial-dehumidifiers"),
    isGradedDehumidifiersPage = location.pathname.includes("graded-dehumidifiers-1"),
    isGradedHumidifiersPage = location.pathname.includes("graded-humidifiers"),
    isHEPASparesPage = location.pathname.includes("hepa-air-purifiers"),
    isDeskFansPage = location.pathname.includes("desk-fans"),
    isDehumidifiersPage = location.pathname.includes("collections/dehumidifiers"),
    isHomeDehumidifiersPage = location.pathname.includes("home-dehumidifiers"),
    isPortableAirConPage = location.pathname.includes("portable-air-conditioners"),
    isGradedPortableAirConPage = location.pathname.includes("graded-portable-air-conditioners"),
    isHEPAPurifiersPage = location.pathname.includes("hepa-air-purifiers"),
    isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

    // add a class to html tag to identify the page
    document.documentElement.classList.add("sd-meaco-015");


// create array for all menu items under "shop" menu
let menuItemsArr = [
    {
        title: "Dehumidifiers",
        link: "https://www.meaco.com/collections/dehumidifiers",
        value: "Dehumidifiers",
        subCats: [
            {
                title: "Home dehumidifiers",
                link: "https://www.meaco.com/collections/home-dehumidifiers",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/1c53bd627f005745763be80458f441ec_dehumidifiershomedehumidifiers_256x256_crop_center.png?v=1677499448",
            },
            {
                title: "Commercial dehumidifiers",
                link: "https://www.meaco.com/collections/commercial-dehumidifiers",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/d57e4e71849f6ddac332dbb29edecd55_dehumidifierscommercialdehumidifiers_256x256_crop_center.png?v=1677499521",
            },
            {
                title: "Graded dehumidifiers",
                link: "https://www.meaco.com/collections/graded-dehumidifiers-1",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/96c1b321a2c09b527ba2e82612cec4f3_dehumidifiersgradeddehumidifiers_256x256_crop_center.png?v=1677499568",
            },
            {
                title: "Dehumidifier spares",
                link: "https://www.meaco.com/collections/dehumidifier-spares",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/26cd86a47b4afb65871d4660606123db_dehumidifiershepafilters_256x256_crop_center.png?v=1677499581",
            },
        ],
    },
    {
        title: "Fans",
        link: "https://www.meaco.com/collections/fans",
        value: "Browse all electric desk fans, pedestals fans and portable fans",
        subCats: [
            {
                title: "Desk fans",
                link: "https://www.meaco.com/collections/desk-fans",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/e51e031648a0abfe8e199e1b979789b1_coolingproductsgradedfans_256x256_crop_center.png?v=1677499691",
            },
            {
                title: "Pedestal fans",
                link: "https://www.meaco.com/products/meacofan-1056-pedestal-air-circulator?keyword=pedestal%20fan",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/28ac18f09d5fc0c0b372b78973487655_coolingproductsfans_256x256_crop_center.png?v=1677499736",
            },
            {
                title: "Cordless fans",
                link: "https://www.meaco.com/products/meacofan-260c-cordless-air-circulator?keyword=cordless%20fan",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/a00fba444db04d2ad2fa4a9d4fd59300_fanscordlessfans_256x256_crop_center.png?v=1677499753",
            },
            {
                title: "Graded fans",
                link: "https://www.meaco.com/collections/graded-air-circulators",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/e51e031648a0abfe8e199e1b979789b1_coolingproductsgradedfans_256x256_crop_center.png?v=1677499691",
            },
            {
                title: "Fan spares",
                link: "https://www.meaco.com/collections/fan-spares",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/f571de159f539cbafd0b3ee4ce9a4068_coolingproductsstoragebags_256x256_crop_center.png?v=1677499763",
            },
        ],
    },
    {
        title: "Air Purifiers",
        link: "https://www.meaco.com/collections/air-purifiers",
        value: "Air Purifiers",
        subCats: [
            {
                title: "Air purifiers",
                link: "https://www.meaco.com/collections/hepa-air-purifiers",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/515fb2d68a4ab50e6713f1184d4a0de6_airpurfierssmartairpurifiers1_256x256_crop_center.png?v=1677499829",
            },
            {
                title: "Air purifier spares",
                link: "https://www.meaco.com/collections/meacoclean-spares",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/d5d1c8bb9706608a43ab93cd615764cb_airpurfiersfilters_256x256_crop_center.png?v=1677499846",
            },
        ],
    },
    {
        title: "Air Conditioners",
        link: "https://www.meaco.com/collections/air-conditioners",
        value: "Air Conditioners",
        subCats: [
            {
                title: "Portable air conditioners",
                link: "https://www.meaco.com/collections/portable-air-conditioners",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/30b3d6359e4aea7e26337bc9d3eacedb_coolingproductsportableair_256x256_crop_center.png?v=1677499895",
            },
            {
                title: "Graded portable air conditioners",
                link: "https://www.meaco.com/collections/graded-portable-air-conditioners",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/59e6301cb08717e218bfc88a0038adbe_coolingproductsgradedportableair_256x256_crop_center.png?v=1677499909",
            },
            {
                title: "Portable air conditioner spares",
                link: "https://www.meaco.com/collections/meacocool-spares",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/d5d1c8bb9706608a43ab93cd615764cb_airpurfiersfilters_c51d7fc7-75a7-481f-8dfc-252fe197c8b7_256x256_crop_center.png?v=1677499920",
            },
        ],
    },
    {
        title: "Humidifiers",
        link: "https://www.meaco.com/collections/humidifier",
        value: "Humidifiers",
        subCats: [
            {
                title: "Graded Humidifiers",
                link: "https://www.meaco.com/collections/graded-humidifiers",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/0711f09f6e8c259577cf6be885a47a64_humidifiersallhumidifiers_256x256_crop_center.png?v=1677499977",
            },
            {
                title: "Humidifier spares",
                link: "https://www.meaco.com/collections/meacodeluxe-spares",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/d900549129b7a60288ff4c89f0442d04_humidifiersfilter_256x256_crop_center.png?v=1677499988",
            },
        ],
    },
    {
        title: "Dehumidifier spares",
        link: "https://www.meaco.com/collections/dehumidifier-spares",
        value: "Dehumidifier spares",
        subCats: [
            {
                title: "HEPA filters",
                link: "https://www.meaco.com/collections/dehumidifier-spares/hepa-filter",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/26cd86a47b4afb65871d4660606123db_dehumidifiershepafilters_2768d319-d577-4317-9b54-8c5b191365cf_256x256_crop_center.png?v=1677500031",
            },
            {
                title: "Charcoal filters",
                link: "https://www.meaco.com/collections/dehumidifier-spares/charcoal-filter",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/46d7437d02c6770f9983352d807e3f9b_dehumidifiersparescharcoalfilters_256x256_crop_center.png?v=1677500040",
            },
            {
                title: "Dust filters",
                link: "https://www.meaco.com/collections/dehumidifier-spares/dust-filter",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/cfda56494de39d1c7a9b556f17a028d3_dehumidifiersparesdustfilters_256x256_crop_center.png?v=1677500060",
            },
            {
                title: "Water tanks",
                link: "https://www.meaco.com/collections/dehumidifier-spares/water-tank",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/56e531b33e35f5787df7c2ac30346ae5_dehumidifierspareswatertanks_256x256_crop_center.png?v=1677500091",
            },
            {
                title: "Drainage hoses",
                link: "https://www.meaco.com/collections/dehumidifier-spares/drainage-hose",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/dehumidifiersparesdrainagehoses_256x256_crop_center.png?v=1677500276",
            },
            {
                title: "Drainage pump",
                link: "https://www.meaco.com/collections/dehumidifier-spares/drainage-pump",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/0863a052f9d10eeb5d8a3b9bbc3d56b6_dehumidifiersparesdrainagepump_256x256_crop_center.png?v=1677500365",
            },
            {
                title: "Castors",
                link: "https://www.meaco.com/collections/dehumidifier-spares/castors",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/85501d335bee99325de602da8bd1b3fd_dehumidifiersparescastors_256x256_crop_center.png?v=1677500384",
            },
            {
                title: "Wall bracket",
                link: "https://www.meaco.com/collections/dehumidifier-spares/wall-bracket",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/640b15726e6e5334ec47f99f30e09bc3_dehumidifierspareswallbracket_256x256_crop_center.png?v=1677500399",
            },
        ],
    },
    {
        title: "Fan spares",
        link: "https://www.meaco.com/collections/fan-spares",
        value: "Fan spares",
        subCats: [
            {
                title: "Storage bag",
                link: "https://www.meaco.com/collections/fan-spares/storage-bag",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/79c773c811af4c7b422b6ae902464386_fansparesstoragebags_256x256_crop_center.png?v=1677500505",
            },
            {
                title: "Remote controls",
                link: "https://www.meaco.com/collections/fan-spares/fan-remote-control",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/7849fd5a4aa4f1ae64d03b2936cf5478_fansparesremotecontrols_256x256_crop_center.png?v=1677500519",
            },
            {
                title: "Cables & plugs",
                link: "https://www.meaco.com/collections/fan-spares/cable-plug",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/f571de159f539cbafd0b3ee4ce9a4068_coolingproductsstoragebags_6ef73145-93c5-4473-aa31-b5c388ab5059_256x256_crop_center.png?v=1677500535",
            },
            {
                title: "Batteries",
                link: "https://www.meaco.com/collections/fan-spares/batteries",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/e6390779de162f36fd594c3adc3fb453_fansparesbatteries_256x256_crop_center.png?v=1677500551",
            },
        ],
    },
    {
        title: "Air Purifier Spares",
        link: "https://www.meaco.com/collections/meacoclean-spares",
        value: "Air Purifier Spares",
        subCats: [
            {
                title: "Filters",
                link: "https://www.meaco.com/collections/meacoclean-spares/ap-filters",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/d5d1c8bb9706608a43ab93cd615764cb_airpurfiersfilters_f9a8dfa6-3bf6-40ee-a8cd-86eb9f0113fb_256x256_crop_center.png?v=1677500568",
            },
            {
                title: "Remote controls",
                link: "https://www.meaco.com/collections/meacoclean-spares/ap-remote-control",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/e3926fa76cc74a4b551133249918f730_airpurifiersparesremotes_256x256_crop_center.png?v=1677500583",
            },
            {
                title: "UV lamps",
                link: "https://www.meaco.com/collections/meacoclean-spares/uv-lamp",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/3d04cbe174ab72b0e12968fbb4c539ae_airpurifiersparesuvlamps_256x256_crop_center.png?v=1677500601",
            },
            {
                title: "Adaptors",
                link: "https://www.meaco.com/collections/meacoclean-spares/adaptor",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/073f1d91749c853732f3c0a0ce612d3a_airpurifiersparesadaptors_256x256_crop_center.png?v=1677500617",
            },
        ],
    },
    {
        title: "Portable air conditioner spares",
        link: "https://www.meaco.com/collections/meacocool-spares",
        value: "Portable Air Conditioner Spares",
        subCats: [
            {
                title: "Ducts",
                link: "https://www.meaco.com/collections/meacocool-spares/duct",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/a9d14a4dbc26af4651bdb126fcb543cc_portableairconditionersparesducts_256x256_crop_center.png?v=1677500632",
            },
            {
                title: "Window adaptors",
                link: "https://www.meaco.com/collections/meacocool-spares/window-adaptors",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/0545eccc38dc1766ca7c62a10141f45c_portableaircondtionerspareswindowadaptors_256x256_crop_center.png?v=1677500647",
            },
            {
                title: "Machine adaptors",
                link: "https://www.meaco.com/collections/meacocool-spares/machine-adaptors",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/1f95a27583b2538af3f6a0206c2ac594_portableairconditonersparesmachineadaptors_256x256_crop_center.png?v=1677500661",
            },
            {
                title: "Window kits",
                link: "https://www.meaco.com/collections/meacocool-spares/window-kits",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/aac90137ced8020c3977cc4b1e491003_portableairconditionerspareswindowkits_256x256_crop_center.png?v=1677500676",
            },
            {
                title: "Castors & remote controls",
                link: "https://www.meaco.com/collections/meacocool-spares/aircon-castor-remote",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/15ef3362ab4487997f1fc9f3a7a7d8bf_portableairconditionersparescastorsremotecontrols_256x256_crop_center.png?v=1677500693",
            },
        ],
    },
    {
        title: "Humidifier Spares",
        link: "https://www.meaco.com/collections/meacodeluxe-spares",
        value: "Humidifier Spares",
        subCats: [
            {
                title: "Filters",
                link: "https://www.meaco.com/collections/meacodeluxe-spares/hum-filter",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/ebbdec5faf4ed8c2685c289a7e084140_sparepartshumidifier_256x256_crop_center.png?v=1677500709",
            },
            {
                title: "Covers",
                link: "https://www.meaco.com/collections/meacodeluxe-spares/hum-cover",
                image: "https://cdn.shopify.com/s/files/1/0371/8378/3043/files/5e5763069b6a73c7f27d209c3e036621_humidifiersparescovers_256x256_crop_center.png?v=1677500725",
            },
        ],
    },
];

// create array for all plp banner text
let plpTextArr = [];

// Polling for an element (cssSelector)
const waitForElements = (cssSelector, multi, callback, maxCalls) => {
    try {
        let elementsCached; // [Configurable] Times out after 6 seconds
        const interval = setInterval(() => {
            try {
                if (multi) {
                    elementsCached = document.querySelectorAll(cssSelector);
                    // Checks if element 'cssSelector' exists
                    if (elementsCached.length) {
                        clearInterval(interval);
                        callback(elementsCached);
                    }
                } else {
                    elementsCached = document.querySelector(cssSelector);
                    // Checks if element 'cssSelector' exists
                    if (elementsCached) {
                        clearInterval(interval);
                        callback(elementsCached);
                    }
                }
                // After trying to find the element for 6 seconds, it stops
                if (typeof maxCalls === "number" && --maxCalls < 0) clearInterval(interval);
            } catch (e) {
                if (debugMode) console.log(">>> ", e.message);
            }
        }, 20);
    } catch (e) {
        if (debugMode) console.log(">>> ", e.message);
    }
};

// create plp elements
const createPLPElements = (plpTitleText, collectionHeader) => {
    try {

        // create PLP container
        const plpContainer = document.createElement("div"),
            plpTitle = document.createElement("h1"),
            plpText = document.createElement("div"),
            plpSubRow = document.createElement("div");
        // add classes
        plpContainer.classList.add("sd-mea-015-plp-container", "container");
        plpTitle.classList.add("sd-mea-015-plp-title");
        plpText.classList.add("sd-mea-015-plp-text");
        plpSubRow.classList.add("sd-mea-015-plp-sub-row");
        if (isFansPage || isSparePage || isAirconPage || isCommDehumidifiersPage || isGradedDehumidifiersPage || isDeskFansPage || isHEPAPurifiersPage || isPortableAirConPage || isGradedPortableAirConPage || isGradedHumidifiersPage) plpContainer.classList.add("sd-mea-015-plp-container-margin-top");
        // add text
        plpTitle.innerText = plpTitleText.innerHTML;
        // if plpTitle includes the words "Browse all" or "Discover", remove it
        if (plpTitle.innerText.includes("Browse all")) plpTitle.innerText = plpTitle.innerText.replace("Browse all", "");
        else if (plpTitle.innerText.includes("Discover")) plpTitle.innerText = plpTitle.innerText.replace("Discover", "");
        // add text to plpText
        if (plpTextArr.length > 0) {
            plpTextArr.forEach((text) => {
                try {
                    // create p element
                    const paragraph = document.createElement("p");
                    // add text
                    paragraph.innerHTML = text;
                    // add button to first paragraph
                    if (plpTextArr.indexOf(text) >= 1) paragraph.classList.add("sd-mea-015-read-more");
                    // insert into DOM
                    plpText.appendChild(paragraph);
                } catch (e) {
                    if (debugMode) console.log(">>> ", e.message);
                }
            });
            // if text > 2, create read more button
            if (plpTextArr.length > 2) {
                // create read more button
                const readMoreBtn = document.createElement("span");
                // add classes
                readMoreBtn.classList.add("sd-mea-015-read-more-btn");
                // add text
                readMoreBtn.innerText = "Read more";
                plpText.insertAdjacentElement("beforeend", readMoreBtn);
                // add event listener
                readMoreBtn.addEventListener("click", () => {
                    try {
                        // remove sd-mea-015-read-more class
                        plpText.querySelectorAll(".sd-mea-015-plp-text p").forEach((text, index) => {
                            try {
                                if (index >= 1) text.classList.toggle("sd-mea-015-read-more");
                            } catch (e) {
                                if (debugMode) console.log(">>> ", e.message);
                            }
                        });
                        // toggle read more button text
                        if (readMoreBtn.innerText === "Read more") readMoreBtn.innerText = "Read less";
                        else readMoreBtn.innerText = "Read more";
                    } catch (e) {
                        if (debugMode) console.log(">>> ", e.message);
                    }
                });
            }
        }
        // loop through menuItemsArr if text === plpTitle
        menuItemsArr.forEach((menuItem) => {
            try {
                if (menuItem.value === plpTitleText.innerHTML)
                    // loop through subCat items
                    menuItem.subCats.forEach((subCatItem) => {
                        try {
                            // create submenu item
                            const subCatImage = document.createElement("img"),
                                subCatLink = document.createElement("a"),
                                subCatTitle = document.createElement("p"),
                                subCatContainer = document.createElement("div");
                            // add classes
                            subCatImage.classList.add("sd-mea-015-subcat-image");
                            subCatLink.classList.add("sd-mea-015-subcat-link");
                            subCatTitle.classList.add("sd-mea-015-subcat-title");
                            subCatContainer.classList.add("sd-mea-015-subcat-container");
                            // add attributes
                            subCatImage.setAttribute("src", subCatItem.image);
                            subCatImage.setAttribute("alt", subCatItem.title);
                            subCatLink.setAttribute("href", subCatItem.link);
                            subCatLink.setAttribute("title", subCatItem.title);
                            // add text
                            subCatTitle.innerText = subCatItem.title;
                            // insert into DOM
                            subCatLink.appendChild(subCatImage);
                            subCatLink.appendChild(subCatTitle);
                            subCatContainer.appendChild(subCatLink);
                            plpSubRow.appendChild(subCatContainer);
                        } catch (e) {
                            if (debugMode) console.log(">>> ", e.message);
                        }
                    });
            } catch (e) {
                if (debugMode) console.log(">>> ", e.message);
            }
        });
        // insert into DOM
        collectionHeader.insertAdjacentElement("beforebegin", plpContainer);

        plpContainer.appendChild(plpTitle);
        plpContainer.appendChild(plpText);
        plpContainer.appendChild(plpSubRow);
    } catch (e) {
        if (debugMode) console.log(">>> ", e.message);
    }
};

// plp changes
const plpChanges = () => {
    try {
        // get plp title
        let plpTitle;
        if (
            isFansPage ||
            isSparePage ||
            isAirconPage ||
            isCommDehumidifiersPage ||
            isHEPASparesPage ||
            isGradedDehumidifiersPage ||
            isGradedHumidifiersPage ||
            isDeskFansPage ||
            isPortableAirConPage
        ) {
            plpTitle = document.querySelector(".container.pr.z_100 h1:not(.sd-hidden)");
        } else {
            plpTitle = document.querySelector(".gf_column.gf_col-md-12.gf_col-sm-12.gf_col-xs-12.gf_col-lg-12 .element-wrap h1:not(.sd-hidden)");
        }
        if (!plpTitle) return;

        // get collectionHeader (container for collection banner)
        let collectionHeader;
        if (isFansPage) {
            collectionHeader = document.querySelector(".page-head.tc.pr.oh.cat_bg_img.page_head_:not(.sd-hidden)");
        } else if (
            isSparePage ||
            isAirconPage ||
            isCommDehumidifiersPage ||
            isHEPASparesPage ||
            isGradedDehumidifiersPage ||
            isGradedHumidifiersPage ||
            isDeskFansPage ||
            isPortableAirConPage
        ) {
            collectionHeader = document.querySelector(".page-head.tc.pr.oh.page_head_:not(.sd-hidden)");
        } else if (isDehumidifiersPage) {
            collectionHeader = document.querySelector("#e-1677251087896:not(.sd-hidden)");
        } else if (isHomeDehumidifiersPage) {
            collectionHeader = document.querySelector("#e-1677251015871:not(.sd-hidden)");
        } else {
            collectionHeader = document.querySelector(".gf_row.gf_equal-height.gf_row-gap-15:not(.sd-hidden)");
        }
        if (!collectionHeader) return;

        // add class to stop multiple changes
        if (plpTitle) plpTitle.classList.add("sd-hidden");
        if (collectionHeader) collectionHeader.classList.add("sd-hidden");

        // get plp title text
        let plpTitleText;
        if (
            isFansPage ||
            isSparePage ||
            isAirconPage ||
            isCommDehumidifiersPage ||
            isHEPASparesPage ||
            isGradedDehumidifiersPage ||
            isGradedHumidifiersPage ||
            isDeskFansPage ||
            isPortableAirConPage
        ) {
            plpTitleText = document.querySelector(".container.pr.z_100 h1");
        } else if(isDehumidifiersPage) {
            plpTitleText = document.querySelector("#e-1677251042583 h1");
        } else if(isHomeDehumidifiersPage) {
            plpTitleText = document.querySelector("#e-1677251015871 h1");
        } else {
            plpTitleText = document.querySelector(".elm.text-edit.gf-elm-center.gf-elm-left-md.gf-elm-left-sm.gf-elm-left-xs.gf-elm-left-lg h1 strong");
        }

        // get plp text
        let plpText;
        if (isSparePage || isHEPASparesPage) {
            plpText = collectionHeader.querySelectorAll("p.mg__0:not(.sd-mea-015-changed");
        } else if (isDehumidifiersPage) {
            plpText = collectionHeader.querySelectorAll("#e-1677251087896 p:not(.sd-mea-015-changed)");
        } else if (isHomeDehumidifiersPage) {
            plpText = collectionHeader.querySelectorAll("#e-1677251015871 p:not(.sd-mea-015-changed)");
        } else if (isAirconPage) {
            // if p tag is empty, make it the second p tag and make second p tag the first
            plpText = collectionHeader.querySelectorAll("p:not(.sd-mea-015-changed");
            if (plpText[0].innerHTML === "") {
                plpText[0].innerHTML = plpText[1].innerHTML;
                plpText[1].innerHTML = "";
            }
        } else {
            plpText = collectionHeader.querySelectorAll(
                "[data-label='Text Block'] .elm.text-edit.gf-elm-left.gf-elm-justify-lg.gf-elm-justify-md.gf-elm-justify-sm.gf-elm-justify-xs p:not(.sd-mea-015-changed"
            );
        }
        if (plpText)
            // loop through text
            plpText.forEach((text) => {
                try {
                    // add class to stop multiple changes
                    text.classList.add("sd-mea-015-changed");
                    // add text to array
                    plpTextArr.push(text.innerHTML);
                } catch (e) {
                    if (debugMode) console.log(">>> ", e.message);
                }
            });
        // create plp elements
        createPLPElements(plpTitleText, collectionHeader);
    } catch (e) {
        if (debugMode) console.log(">>> ", e.message);
    }
};

const mutationObserver = (functionToCall, selector) => {
    try {
        const targetNode = document.querySelector(selector);
        const config = {
            attributes: true,
            childList: true,
            subtree: true,
        };
        const observer = new MutationObserver(function () {
            functionToCall();
        });
        observer.observe(targetNode, config);
    } catch (e) {
        if (debugMode) console.log(e.message);
    }
};

// wait for cat banner on mobile
waitForElements("#nt_content", false, () => {
    try {
        if (location.pathname.includes("/collections/")) {
            plpChanges();
            mutationObserver(plpChanges, "body");
        }
    } catch (e) {
        if (debugMode) console.log(">>> ", e.message);
    }
});



  function getEncodedProductSku(sku) {
      const t = unescape(encodeURIComponent(sku));
      let n = "";
      for (let e = 0; e < t.length; e++) n += t.charCodeAt(e).toString(16);
      return n;
  }

  function generateStars(rating, nmrReviews, outOfStock) {
      return `
                    <div class="sd-016-info">
                        <div class="sd-star-rating-info">
                            <div class="sd-star-rating">
                                <div class="stars-row stars-row--empty">
                                    ${[...Array(5)]
                                        .map(function () {
                                            return `
                                                <div class="stars-row__star">
                                                    <div class="star-icon-wrapper" style="width: 100%;">
                                                        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill="currentColor" fill-rule="evenodd" d="M16 0.533l4 12.267h12l-9.867 6.933 4 12-10.133-7.467-10.133 7.467 4-12-9.867-6.933h12z"></path>
                                                        </svg>
                                                    </div>
                                                </div>
                                            `;
                                        })
                                        .join("")}
                                </div>
                                <div class="stars-row stars-row--full">
                                    ${[...Array(5)]
                                        .map(function (elem, index) {
                                            var percentage = rating - (index + 1);

                                            if (percentage >= 0) {
                                                percentage = 100;
                                            } else if (percentage <= -1) {
                                                percentage = 100;
                                            } else {
                                                percentage = (1 - Math.abs(percentage)) * 100;
                                            }

                                            return `
                                                <div class="stars-row__star">
                                                    <div class="star-icon-wrapper" style="width: ${percentage}%;">
                                                        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill="currentColor" fill-rule="evenodd" d="M16 0.533l4 12.267h12l-9.867 6.933 4 12-10.133-7.467-10.133 7.467 4-12-9.867-6.933h12z"></path>
                                                        </svg>
                                                    </div>
                                                </div>
                                            `;
                                        })
                                        .join("")}
                                </div>
                            </div>
                            <span class="sd-count">${nmrReviews} reviews</span>
                        </div>
                    </div>
                `;
  }

  // Grab the HTML from another page
  function getHTML(url, callback) {
      try {
          // Feature detection
          if (!window.XMLHttpRequest) return;

          // Create new request
          var xhr = new XMLHttpRequest();

          // Setup callback
          xhr.onload = function () {
              try {
                  if (callback && typeof callback === "function") {
                      callback(this.responseXML);
                  }
              } catch (e) {
                  if (debugMode) console.log(e.message);
              }
          };

          // Get the HTML
          xhr.open("GET", url);
          xhr.responseType = "document";
          xhr.send();
      } catch (e) {
          if (debugMode) console.log(e.message);
      }
  }
/*
  function processProducts() {
      var products = document.querySelectorAll("#shopify-section-collection_page .pr_grid_item.product:not(.reviews_processing):not(.reviews_processed)");

      products.forEach(function (product) {
          if (product.querySelector("div.main-img")) {
              product.classList.add("reviews_processing");

              var outOfStock = product.querySelector(".nt_label.out-of-stock");

              getHTML(product.querySelector("a").getAttribute("href"), function (html) {
                  var etrustedSku = html.querySelector("etrusted-widget");

                  if (etrustedSku) {
                      etrustedSku = etrustedSku.dataset.sku;

                      if (etrustedSku) {
                          etrustedSku = etrustedSku.split(",");
                          etrustedSku = etrustedSku[0];

                          if (etrustedSku) {
                              fetch(
                                  `https://integrations.etrusted.com/feeds/grades/v1/channels/chl-c018ad70-6db4-4b2f-8cb6-979e216b44f9/products/sku/${getEncodedProductSku(
                                      etrustedSku
                                  )}/feed.json`
                              )
                                  .then((response) => response.json())
                                  .then((result) => {
                                      if (result?.grades?.overall) {
                                          var starsStockHTML = generateStars(result.grades.overall.rating, result.grades.overall.count, outOfStock);

                                          product.querySelector("h3").insertAdjacentHTML("afterend", starsStockHTML);
                                      }
                                  });
                          }
                      }
                  }
              });
          }
      });
  }
*/
  function observeBody() {
      waitForElements("body", false, function (bodyElem) {
          try {
              new MutationObserver(function () {
                  try {
                      processProducts();
                  } catch (e) {
                      if (debugMode) console.log(e.message);
                  }
              }).observe(bodyElem, { attributes: true, childList: true, subtree: true, characterData: true });
          } catch (e) {
              if (debugMode) console.log(e.message);
          }
      });
  }

  if (location.pathname.includes("collections")) {
      processProducts();
      observeBody();
  }